import React from "react";
import FullMarksLoader from "../../components/ReUsableComponents/FullMarksLoader";

interface ButtonProps {
  text: string;
  icon?: React.ReactNode;
  iconPosition?: "left" | "right";
  disabled?: boolean;
  onClick?: () => void;
  loader?:boolean;
  className?:string;
}

const AuthButton: React.FC<ButtonProps> = ({
  text,
  icon,
  iconPosition = "left",
  disabled = false,
  onClick,
  loader,
  className,
}) => {
  return (
    <div>
      <button
        onClick={onClick}
        disabled={disabled || loader}
        className={`${
          className || "text-base"
        } relative flex items-center justify-center py-[10px] px-[22px] rounded-md font-medium font-gully transition duration-200 whitespace-nowrap ${
          disabled || loader
            ? "bg-satPrepLightGrey text-satPrepDarkGrey cursor-not-allowed"
            : "bg-satPrepAccent text-satPrepWhite hover:bg-satPrepWhite hover:text-satPrepAccent hover:py-[9x] hover:px-[21px] hover:border hover:border-satPrepAccent" 
        }`}
        style={{
          boxShadow: "0px 4px 12px 0px rgba(71, 172, 255, 0.2)",
        }}
      >
        <span
          className={`flex items-center ${
            loader ? "invisible" : "visible"
          }`}
        >
          {icon && iconPosition === "left" && (
            <span className="mr-[10px] flex items-center">{icon}</span>
          )}
          <span className="my-auto">{text}</span>
          {icon && iconPosition === "right" && (
            <span className="ml-2 flex items-center">{icon}</span>
          )}
        </span>
        {loader && (
          <span className="absolute top-50 flex items-center justify-center">
            <FullMarksLoader width={30} height={30} />
          </span>
        )}
      </button>
    </div>
  );
};

export default AuthButton;
